import axios from "axios";
import store from "../store";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

export const baseURL = process.env.REACT_APP_BACKEND;
const fetcher = axios.create({ baseURL });

export const apiRequest = async ({
  method,
  url,
  payload,
  successMessage,
  showError,
  dispatchFunct = () => null,
}) => {
  const headers = {
    "Content-Type": "application/json",
  };
  const args =
    method?.toLowerCase() === "get" || method?.toLowerCase() === "delete"
      ? [url, payload]
      : [url, payload, headers];
  try {
    const data = await fetcher[method](...args);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      error.toString();

    if (showError) {
      dispatchFunct();
      Swal.fire({
        title: "Error",
        text: message,
        icon: "error",
        confirmButtonText: "Ok",
      });
    }

    // Notify the user via toast before re-throwing so callers can handle it too
    toast.error(message);
    throw error;
  }
};

export const verifyPayerId = async (payerId, errormsg, successmsg) => {
  try {
    const data = await axios.get(
      `${baseURL}cbs/customer_details?payerId=${payerId}`
    );
    if (data.status === "success") {
      successmsg();
      toast.success("Payer ID verified successfully");
    }
    return data;
  } catch (error) {
    if (error?.response && error?.response?.status === 404) {
      toast.error("Payer ID not found");
    }
  }
};
